import React from 'react';
import { motion } from 'framer-motion';
export function System() {
  const steps = [{
    num: '01',
    title: 'Narrativa de Marca',
    desc: 'Construimos la identidad y el posicionamiento de tu restaurante para diferenciarte de la competencia.'
  }, {
    num: '02',
    title: 'Contenido Estratégico',
    desc: 'Generamos contenido experiencial con influencers que muestre la experiencia real en tu restaurante.'
  }, {
    num: '03',
    title: 'Meta Ads Inteligentes',
    desc: 'Amplificamos el alcance con publicidad digital para atraer nuevos clientes de forma predecible y escalable.'
  }];
  return <section id="el-sistema" className="py-24 bg-gradient-2 relative" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-150">
        <div className="text-center mb-20" data-id="element-151">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-accent text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-152">
            LA METODOLOGÍA
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-153">
            Motor de Crecimiento para <br className="hidden md:block" data-id="element-154" />
            <span className="text-gradient" data-id="element-155">Negocios Gastronómicos</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-text-secondary text-xl" data-id="element-156">
            Sistema de Demanda Sostenida
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-157">
          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-[#0a0a0a] border border-white/5 rounded-xl p-8 relative overflow-hidden group hover:border-accent/30 transition-colors duration-300" data-id="element-158">
              <div className="absolute top-0 left-0 w-full h-1 bg-accent transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-159" />
              <div className="absolute top-0 left-0 w-full h-1 bg-white/5" data-id="element-160" />

              <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-accent/10 border border-accent/20 text-accent font-heading font-bold text-xl mb-8" data-id="element-161">
                {step.num}
              </div>

              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-162">
                {step.title}
              </h3>
              <p className="text-text-secondary leading-relaxed" data-id="element-163">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}